import React, { useState, useCallback, useEffect } from "react";
import {
  Button,
  Card,
  Box,
  Stack,
  Chip,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  TableContainer,
  Paper,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CreateVoucher from "./create";
import getAllgeneralProductList from "../../../services/offer";
import productPricing from "../../../services/product_pricing";
import { useDispatch, useSelector } from "react-redux";
import { showLoader, hideLoader } from "../../../redux/loader/actions";
import moment from "moment";

import CustomDatagrid from "../../../components/datagrid";
const useStyles = makeStyles({
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginBottom: "10px",
    marginRight: "15px",
  },
  animatedButton: {
    background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
    color: "#fff",
    padding: "10px 30px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "5px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
    },
  },
});

const VoucherTable = () => {
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);
  const [searchparams, setSearchparams] = useState();
  const [rowCount, setRowCount] = useState(0);
  const [mode, setMode] = useState("");
  const menuItems = useSelector((state) => state.menuReducer.items);
  const createMenuItem = menuItems
    ?.find((item) => item.name.toLowerCase() === "offer")
    ?.submenus?.find((item) => item.name.toLowerCase() === "general");
  const isDisabled = createMenuItem?.access_type === "read_write";
  const [sortOrder, setSortOrder] = useState([{ field: "id", sort: "desc" }]);
  const [userList, setUserList] = useState([]);
  const [productfilterList, setProductfilterList] = useState([]);
  const [planfilterList, setPlanfilterList] = useState([]);
  const [offerData, setOfferData] = useState([]);

  const [voucherData, setVoucherData] = useState({
    code: "",
    validFrom: "",
    validTo: "",
    purpose: "",
    discount: "",
    discountType: "INR",
    products: [],
    plans: [],
    frequency: "",
  });
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const dispatch = useDispatch();
  const handleCreateClick = () => {
    setOpenModal(false);
  };

  const [filters, setFilters] = useState({
    frequency: "",
    product: "",
    plan: "",
    status: "",
    from: null,
    to: null,
  });

  const handleReset = () => {
    setFilters({
      frequency: "",
      product: "",
      plan: "",
      status: "",
      from: null,
      to: null,
    });
    setMode();
    setSearchparams({});
  };

  const handleSearch = () => {
    const logData = {
      frequency: filters?.frequency,
      product: filters?.product,
      plan: filters?.plan,
      status: filters?.status,
      from: filters?.from
        ? moment
          .utc(filters?.from)
          .startOf("day")
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]")
        : null,
      to: filters?.to
        ? moment
          .utc(filters?.to)
          .endOf("day")
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]")
        : null,
    };
    setPaginationModel({
      page: 0,
      pageSize: 10,
    });

    setSearchparams(logData);
  };
  const userListRows = userList?.map((data, index) => {
    const currentDate = moment().startOf("day");
    const validFromDate = moment(data.valid_from).startOf("day");
    const validToDate = moment(data.valid_to).endOf("day");
    let status = "Inactive";

    if (currentDate.isBefore(validFromDate)) {
      status = "Upcoming";
    } else if (currentDate.isSameOrAfter(validFromDate) && currentDate.isSameOrBefore(validToDate)) {
      status = "Active";
    } else {
      status = "Expired";
    }
    return {
      id: data.uuid,
      sno_id: paginationModel.page * paginationModel.pageSize + index + 1,
      uuid: data.uuid,
      productName: data.productDetails.name,
      productPlan: data.productPlanDetails.product_plan_name,
      valid_from: moment
        .utc(data.valid_from)
        .startOf("day")
        .format("DD/MM/YYYY"),
      valid_to: moment.utc(data.valid_to).endOf("day").format("DD/MM/YYYY"),
      offer_discount: `${data.offer_discount_type === "rupee" ? "₹" : "%"} ${data.offer_discount
        } `,
      createdon: moment
        .utc(data.created_at)
        .startOf("day")
        .format("DD/MM/YYYY"),
      frequency: data.frequency
        ? data.frequency.charAt(0).toUpperCase() + data.frequency.slice(1)
        : "",
      vouchercuponnumber: data.offer_code,
      purposeofvoucher: data.offer_description,
      utilizeduserCount: data.generalOfferUserMapping?.length || 0,
      status,
    };
  });

  const handleEdit = (data) => {
    setMode("edit");
    getOfferByid(data);
    setOpenModal(true);
  };
  const handleRecreate = (data) => {
    setMode("recreate");
    getOfferByid(data);
    setOpenModal(true);
  };

  const columns = [
    {
      field: "sno_id",
      headerName: "S.No",
      width: 100,
      headerAlign: "left",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
      sortable: false,
    },
    {
      field: "createdon",
      headerName: "Created On",
      width: 150,
      headerAlign: "left",
      align: "center",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
    },
    {
      field: "valid_from",
      headerName: "Valid From",
      width: 150,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      align: "center",
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
    },
    {
      field: "valid_to",
      headerName: "Valid To",
      width: 150,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      align: "center",
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
    },
    {
      field: "vouchercuponnumber",
      headerName: "Voucher Coupon Number",
      width: 200,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
      align: "center",
    },
    {
      field: "purposeofvoucher",
      headerName: "Purpose of Voucher Coupon",
      width: 150,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
      align: "center",
    },
    {
      field: "productPlan",
      headerName: "Plan",
      width: 150,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
      align: "center",
    },
    {
      field: "productName",
      headerName: "Product",
      width: 150,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      align: "center",
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
    },
    {
      field: "frequency",
      headerName: "Frequency",
      width: 150,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
      align: "center",
    },
    {
      field: "utilizeduserCount",
      headerName: "Utilized User",
      width: 150,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      align: "center",
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
    },

    {
      field: "offer_discount",
      headerName: " Voucher Coupon Discount",
      width: 200,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
      align: "center",
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      headerAlign: "left",
      disableColumnMenu: true,
      sortable: false,
      align: "center",
      renderCell: (params) => {
        let variant;
        switch (params.value) {
          case "Used":
            variant = "warning";
            break;
          case "Active":
            variant = "success";
            break;
          case "Expired":
            variant = "error";
            break;
          case "Upcoming":
            variant = "info";
            break;
          default:
            variant = "default";
        }

        return (
          <Chip
            label={params.value}
            color={variant}
            size="small"
            variant="outlined"
            style={{ textTransform: "capitalize" }}
          />
        );
      },
    },

    ...(isDisabled
      ? [
        {
          field: "action",
          headerName: "Action",
          width: 150,
          disableColumnMenu: true,
          sortable: false,
          headerAlign: "left",
          align: "center",
          renderCell: (params) => {
            const { status, uuid } = params.row;
            return (
              <div style={{ textAlign: "left", width: "100%" }}>
                {status === "Upcoming" && (
                  <Chip
                    label="Edit"
                    size="small"
                    variant="outlined"
                    style={{
                      textTransform: "capitalize",
                      marginRight: "3px",
                    }}
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleEdit(uuid)}
                  />
                )}
                <Chip
                  label="Recreate"
                  size="small"
                  variant="outlined"
                  style={{ textTransform: "capitalize" }}
                  sx={{ cursor: "pointer" }}
                  onClick={() => handleRecreate(uuid)}
                />
              </div>
            );
          },
        },
      ]
      : []),
  ];

  const getOfferByid = useCallback((id) => {
    dispatch(showLoader());
    const onSuccess = (res) => {
      dispatch(hideLoader());
      setOfferData(res?.data?.data);
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      console.log(err?.response?.data?.msg);
    };
    getAllgeneralProductList
      .getAllgeneralOfferId(id)
      .then(onSuccess, onFailure);
  });

  const fetchUsers = useCallback(async () => {
    dispatch(showLoader());
    try {
      const response = await getAllgeneralProductList.getAllgeneralProductList(
        paginationModel.page + 1,
        paginationModel.pageSize,
        searchparams
      );
      if (response?.data?.status) {
        setUserList(response.data.data);
        setRowCount(response.data.pagination.totalItems || 0);
      } else {
        setUserList([]);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      dispatch(hideLoader());
    }
  }, [paginationModel.page, paginationModel.pageSize, searchparams, dispatch]);
  useEffect(() => {
    fetchUsers();
  }, [paginationModel, sortOrder]);

  useEffect(() => {
    if (searchparams) {
      fetchUsers();
    }
  }, [searchparams]);

  const getAllgeneralProductFilter = useCallback(
    async (user) => {
      dispatch(showLoader());
      const pageSize = 1000;
      try {
        const response =
          await getAllgeneralProductList.getAllgeneralProductFilter(
            pageSize,
            user
          );
        if (response?.data?.status && response.data.data) {
          setProductfilterList(response.data.data);
        } else {
          setProductfilterList([]);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        dispatch(hideLoader());
      }
    },
    [dispatch]
  );

  useEffect(() => {
    getAllgeneralProductFilter();
  }, []);

  const getAllgeneralPlanFilter = useCallback(
    async (product) => {
      dispatch(showLoader());
      try {
        const response = await productPricing.getPlanAgainstProduct(product);
        if (response?.data?.status && response.data.data) {
          setPlanfilterList(response.data.data);
        } else {
          setPlanfilterList([]);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        dispatch(hideLoader());
      }
    },
    [dispatch]
  );
  useEffect(() => {
    if (filters.product) {
      getAllgeneralPlanFilter(filters.product);
    } else {
      setPlanfilterList([]);
    }
  }, [filters.product, getAllgeneralPlanFilter]);

  return (
    <>
      <Box style={{ padding: "20px" }}>
        <Stack direction="row" justifyContent="flex-end" spacing={2}>
          {isDisabled && (
            <Button
              variant="contained"
              onClick={() => setOpenModal(true)}
              sx={{
                background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                color: "#fff",
                borderRadius: "8px",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                textTransform: "uppercase",
                fontWeight: "bold",
                "&:hover": {
                  background:
                    "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
                  boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.3)",
                },
              }}
            >
              Create Offer
            </Button>
          )}
        </Stack>
        <Card elevation={3} sx={{ marginBottom: "15px", mt: 2 }}>
          <Grid container spacing={2} sx={{ p: 2 }}>
            <Grid item xs={12} md={3}>
              <Box
                sx={{ display: "flex", flexDirection: "column", width: "100%" }}
              >
                <TextField
                  id="outlined-basic"
                  value={
                    filters.from
                      ? moment(filters.from).format("YYYY-MM-DD")
                      : ""
                  }
                  onChange={(e) => {
                    if (e.target.value) {
                      const localDate = new Date(e.target.value);
                      setFilters({ ...filters, from: localDate });
                    }
                  }}
                  label="Created On From Date"
                  variant="outlined"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={3}>
              <Box
                sx={{ display: "flex", flexDirection: "column", width: "100%" }}
              >
                <TextField
                  id="outlined-basic"
                  value={
                    filters.to ? moment(filters.to).format("YYYY-MM-DD") : ""
                  }
                  onChange={(e) => {
                    if (e.target.value) {
                      const localDate = new Date(e.target.value);
                      setFilters({ ...filters, to: localDate });
                    }
                  }}
                  label="Created On To Date"
                  variant="outlined"
                  type="date"
                  inputProps={{
                    min: filters.from
                      ? moment(filters.from).format("YYYY-MM-DD")
                      : "",
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Product</InputLabel>
                <Select
                  name="product"
                  value={filters.product}
                  onChange={(e) => {
                    const selectedProductUuid = e.target.value;
                    setFilters({
                      ...filters,
                      product: selectedProductUuid,
                      plan: "",
                    });
                    getAllgeneralPlanFilter(selectedProductUuid);
                  }}
                  label="Product"
                >
                  {productfilterList?.length === 0 ? (
                    <MenuItem value="" disabled>
                      No products available
                    </MenuItem>
                  ) : (
                    Array.from(
                      new Map(
                        productfilterList.map((product) => [
                          product.productDetails?.name,
                          product.productDetails?.uuid,
                        ])
                      ).entries()
                    ).map(([productName, productUuid]) => (
                      <MenuItem key={productUuid} value={productUuid}>
                        {productName || "Unknown Product"}
                      </MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Plan</InputLabel>
                <Select
                  name="plan"
                  label="plan"
                  value={filters.plan}
                  onChange={(e) => {
                    const selectedProductUuid = e.target.value;
                    setFilters({ ...filters, plan: selectedProductUuid });
                  }}
                >
                  {planfilterList.map((role) => (
                    <MenuItem key={role.uuid} value={role.product_plan_uuid}>
                      {role.product_plan_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  name="status"
                  value={filters.status}
                  label="Status"
                  onChange={(e) =>
                    setFilters({ ...filters, status: e.target.value })
                  }
                >
                  <MenuItem value="">None</MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="upcoming">Upcoming</MenuItem>
                  <MenuItem value="expired">Expired</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Frequency</InputLabel>
                <Select
                  name="frequency"
                  label="Frequency"
                  value={filters.frequency}
                  onChange={(e) => {
                    setFilters({ ...filters, frequency: e.target.value });
                  }}
                >
                  <MenuItem value="">None</MenuItem>
                  <MenuItem value="monthly">Monthly</MenuItem>
                  <MenuItem value="quarterly">Quarterly</MenuItem>
                  <MenuItem value="halfyearly">HalfYearly</MenuItem>
                  <MenuItem value="yearly">Yearly</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box className={classes.buttonContainer}>
            <Button variant="outlined" onClick={handleReset}>
              Reset
            </Button>
            <Button
              className={classes.animatedButton}
              variant="contained"
              onClick={handleSearch}
              size="small"
            >
              Search
            </Button>
          </Box>
        </Card>

        <Card elevation={3}>
          <TableContainer component={Paper}>
            {userListRows.length === 0 ? (
              <Box sx={{ textAlign: "center", padding: 2 }}>
                <Typography variant="h6" color="textSecondary">
                  No data found
                </Typography>
              </Box>
            ) : (
              <CustomDatagrid
                rows={userListRows}
                columns={columns}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                rowCount={rowCount}
                onSortModelChange={setSortOrder}
                disableSelectionOnClick={true}
                checkboxSelection={false}
                getRowId={(row) => row.uuid}
                pagination
                pageSizeOptions={[5, 10, 20]}
              />
            )}
          </TableContainer>
        </Card>
        <CreateVoucher
          open={openModal}
          setOpenModal={setOpenModal}
          onCreate={handleCreateClick}
          voucherData={voucherData}
          setVoucherData={setVoucherData}
          offerData={offerData}
          setOfferData={setOfferData}
          mode={mode}
          setMode={setMode}
          fetchUsers={fetchUsers}
        />
      </Box>
    </>
  );
};

export default VoucherTable;
